// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/QuestionForm.test.tsx
import { Text } from "@radix-ui/themes";
import cx from "classnames";

import {
  agentComponentIdAttr,
  CHAT_ATOM_AGENT_COMPONENT_IDS,
} from "../agentComponents/chatAtomRegistry";

export type ChoiceRowProps = {
  label: string;
  description?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  /** Default `question-option` — product and e2e already pin this string. */
  "data-testid"?: string;
};

/**
 * Slot option row — Radix RadioCards select treatment:
 * resting fill/stroke-free, selected = 2px accent outline (not a thick glow ring).
 * why: ring-4/50 on selected felt off vs Themes RadioCards `outline: 2px solid`.
 */
export function ChoiceRow({
  label,
  description,
  selected = false,
  disabled = false,
  onClick,
  "data-testid": dataTestId = "question-option",
}: ChoiceRowProps) {
  return (
    <button
      {...agentComponentIdAttr(CHAT_ATOM_AGENT_COMPONENT_IDS.choiceRow)}
      data-testid={dataTestId}
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      onClick={onClick}
      className={cx(
        // why: min-w-0 so truncate works inside the sm:grid-cols-2 option track.
        "relative flex w-full min-w-0 items-center justify-between gap-2 overflow-hidden rounded-lg border border-transparent bg-transparent px-3 py-2 text-left outline-none",
        // Radix RadioCards: checked → 2px accent outline; focus-visible is separate.
        selected && "outline outline-2 outline-puntt-accent-9",
        !disabled &&
          "focus-visible:outline focus-visible:outline-2 focus-visible:outline-puntt-accent-8",
        selected && !disabled && "focus-visible:outline-puntt-accent-10",
        !selected && !disabled && "hover:bg-puntt-neutral-gray-3",
        disabled && "cursor-default opacity-40",
        !disabled && "cursor-pointer",
      )}
      title={description}
    >
      <Text
        as="p"
        size="2"
        weight="medium"
        className="min-w-0 flex-1 truncate text-puntt-neutral-gray-11"
      >
        {label}
      </Text>
      {description ? (
        <Text
          as="span"
          size="1"
          className="max-w-[45%] shrink-0 truncate text-puntt-neutral-gray-11"
        >
          {description}
        </Text>
      ) : null}
    </button>
  );
}
